var _global = typeof window !== 'undefined' ? window : typeof global !== 'undefined' ? global : typeof self !== 'undefined' ? self : {};

_global.SENTRY_RELEASE = {
  id: "24fa3362f43a79dbc549c2328d9266e326f9a45e"
};
_global.SENTRY_RELEASES = _global.SENTRY_RELEASES || {};
_global.SENTRY_RELEASES["icloudready-newwebsite@icloudready"] = {
  id: "24fa3362f43a79dbc549c2328d9266e326f9a45e"
};